import { convertCurrency } from 'src/common/helpers/currency-helper';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { showNotification } from './show-notification';

export const validateAlternateTenderRequired = async (
  amountApproved: number,
  amountDue: number,
): Promise<void> => {
  const { requiresAlternateTenderNotification } = getCurrentXLRConfig();
  if (amountApproved < amountDue && requiresAlternateTenderNotification) {
    await showNotification(
      'EwicAlternateTenderNotificationTitle',
      'EwicAlternateTenderNotificationMessage',
      EmeraldDialogTypes.Info,
      undefined,
      {
        arg: convertCurrency(Number(amountApproved)),
      },
    );
  }
};
